import { PhotoModel } from '.'

export class CustomPhoto {
  public id: string
  public title: string;
  public description: string;
  public src: string;
  public height: number;
  public width: number;
  public onLoad?: any;

  constructor(photo: PhotoModel, photoLoadedFct: any){
    this.id = photo.id;
    this.title = photo.title;
    this.description = photo.description;
    this.src = this.getThumbSrc(photo.displaySrc);
    this.width = photo.width;
    this.height = photo.height;
    this.onLoad = photoLoadedFct;
  }

  private getThumbSrc(src: string): string{
    const i: number = src.lastIndexOf('/') + 1;
    return src.slice(0, i) + 'THUMB_' + src.slice(i)
  }
}


// WEBPACK FOOTER //
// ./src/common/models/customPhoto.mdl.ts